export const enum StorageStateKeysEnum {
	USER_KEY = "user",
	USER_TOKEN = "userToken",
	SECONDARY_USER = "secondaryUser",
	SECONDARY_TOKEN = "secondaryToken",
	ACCOUNT_ACTIVATION = "accountActivation",
	ACC = "acc",
	REALITY_CHECK_EXPIRATION = "reality-check-expiration",
	AUTO_LOGOUT_PERIOD = "auto-logout-period",
	DSV = "dsv",
	TOKEN_EXPIRATION_LAST_CHANGE = "token-expiration-last-change",
	SECONDARY_TOKEN_EXPIRATION_DATE = "secondary-token-expiration-date",
	LOGIN_HISTORY = "loginHistory",
	GIG_TOKEN = "gigToken",
	USER_ACCOUNTS = "userAccounts",
	USER_MATCHING = "user_matching",
	UDC = "udc",
	CONFIRMATION_DATA = "confirmation_data",
	SLN = "sln",
	SESSION_EXPIRATION_TIME = "session-expiration-time",
	GS = "gs",
	WELCOME_POPUP = "welcomePopup",
	THEME = "theme",
	USER_DATA_TO_BE_CONFIRMED = "user-data-to-be-confirmed",
	MITID_LOGIN_HASH = "mitid-login-hash",
	ONBOARDING_REGISTER_POPUP = "onboardingRegisterPopup",
	ONBOARDING_NEWSLETTER_POPUP = "onboardingNewsletterPopup",
	ONBOARDING_WELCOME_POPUPS = "onboardingWelcomePopups",
	DECLINED_CAP_UPDATE = "declineCapUpdate",
	AFC = "afc",
	CHAT_BOX_VISIBLE = "isChatBoxVisible",
	MOBILE_APP_POPUP_DISPLAY = "hideMobileAppPopup",
	PROMO_BAYER04_CLOSED = "promoBayer04Closed",
	HYBRID_PN_TOKEN = "pushNotificationToken",
	BB_DESCRIPTION_CLOSED = "BB-description-closed",
	NOTIFICATION_INFO_CLOSED = "notification-info-closed",
	GAME_OVERLAY_FINISH_TIME = "gameOverlayFinishTime",
	REALITY_CHECK_TOTAL_TIME = "reality-check-total-time",
	LAST_ACTIVE_TIMESTAMP = "last-active-timestamp",
	MOBILE_GROUPED_SPORTS_ID = "mobile_grouped_sports_id",
	IS_MULTI_SELECT_ACTIVE = "is_multi_select_active",
	REQUEST_ID = "request-id",
	SCROLL_POSITION = "scroll-position",
	XTREMEPUSH = "xtremepush.data",
	OFFER_SUGGESTED_SEARCH_LIST = "o_ss_list",
	OFFER_SUGGESTED_SEARCH_VERSION = "o_ss_version",
	PREMATCH_MENU_DATA = "prematch_menu",
	PREMATCH_MENU_HASH = "prematch_menu_hash",
	PREMATCH_MENU_VERSION = "prematch_menu_version",
	PREMATCH_MENU_EXPANDED_SPORTS = "prematch_menu_expanded_sports",
	GAME_SESSION_DATA = "gsd",
	WAITING_PERIOD_STATE = "waiting-period-state",
	USER_MATCHING_DATA = "user-matching-data",
	CASINO_PLAY_TYPE = "casino-play-type",
}

export interface ILocalStorageProvider {
	initialLoad: () => Promise<void>;
	get: (key: StorageStateKeysEnum) => unknown | null;
	set: (key: StorageStateKeysEnum, value: any) => void;
	remove: (key: StorageStateKeysEnum) => void;
	flush: () => void;
}
